import React, { FC } from 'react';

import Card from 'components/Card';
import useOpenHiddenCards from 'helpers/useOpenHiddenCards';

import { CardSchema } from 'constants/graphqlTypes';
import { StyledCardWrap, StyledCardContent, StyledSelectionOverlay, StyledCheckbox } from './styled';

interface ISavedPicksItemProps {
  item: CardSchema;
  isSelectable: boolean;
  isChecked: boolean;
  isDark: boolean;
  handler?: (cardId: string) => void;
}

const CheckIcon: FC = () => (
  <svg width="12" height="10" viewBox="0 0 12 10" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clipPath="url(#clip0_8_2)">
      <path
        d="M1 5.5L4.28694 8.62259C4.50022 8.82521 4.84147 8.80081 5.02375 8.56991L11 1"
        stroke="#181800"
        strokeLinecap="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_8_2">
        <rect width="12" height="10" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

const SavedPicksItem: FC<ISavedPicksItemProps> = ({ isSelectable, isChecked, handler, item, isDark }) => {
  const { cardId, isHidden } = item;
  const { openIds } = useOpenHiddenCards();

  const allowSelect = !isHidden || !!openIds?.includes(cardId);
  const canSelect = allowSelect && isSelectable;

  const handleOverlayClick = (e: React.MouseEvent) => {
    e.stopPropagation();
    if (allowSelect && handler) {
      handler(cardId);
    }
  };

  return (
    <StyledCardWrap>
      {canSelect && (
        <StyledSelectionOverlay
          isSelected={isChecked}
          onClick={handleOverlayClick}
          role="button"
          aria-label={isChecked ? 'Deselect saved pick' : 'Select saved pick'}
          aria-pressed={isChecked}
        >
          <StyledCheckbox isSelected={isChecked}>{isChecked && <CheckIcon />}</StyledCheckbox>
        </StyledSelectionOverlay>
      )}
      <StyledCardContent isSelectable={canSelect}>
        <Card
          disableLinks={!!isSelectable}
          card={item}
          shouldDisableLongTap
          showActivity={false}
          isDark={isDark}
          disableAnimation
        />
      </StyledCardContent>
    </StyledCardWrap>
  );
};

export default SavedPicksItem;
